import { CloseOutlined } from '@ant-design/icons';
import { Tag, TagProps } from '@sinohealth/butterfly-ui-components';
import classNames from 'classnames';
import React from 'react';
import styles from './index.less';

interface PatientTagProps extends TagProps {
  border?: boolean;
  padding?: boolean;
  size?: 'small' | 'big';
}

const PatientTag: React.FC<PatientTagProps> = (props) => {
  const { border, padding = true, size = 'small', ...rest } = props;

  const color = {
    blue: 'var(--primary-color)',
    orange: 'var(--warning-color-border)',
  };
  return (
    <Tag
      {...rest}
      className={classNames(
        props?.className,
        styles['tag-round'],
        !border && styles['tag-border-none'],
        !props.color && styles['tag-default'],
        padding && styles['patient-tag'],
        size === 'big' && styles['big-tag'],
        styles.patientTag,
      )}
      closeIcon={
        <CloseOutlined
          style={{
            fontSize: 12,
            color: color[props?.color as keyof typeof color],
          }}
        />
      }
    >
      {props?.children}
    </Tag>
  );
};

export default PatientTag;
